module.exports = __webpack_public_path__ + "img/early_04.affe9053.png";